import api from './client';
import type { User, UserProfile } from '@/types';
import { transformUser } from '@/lib/utils';

function transformUserProfile(apiProfile: any): UserProfile {
  if (!apiProfile) return null as any;
  return {
    ...transformUser(apiProfile),
    followersCount: apiProfile.followers_count ?? apiProfile.followersCount ?? 0,
    followingCount: apiProfile.following_count ?? apiProfile.followingCount ?? 0,
    blahblahsCount: apiProfile.blahblahs_count ?? apiProfile.blahblahsCount ?? 0,
    isFollowing: apiProfile.is_following ?? apiProfile.isFollowing ?? false,
    isBlocked: apiProfile.is_blocked ?? apiProfile.isBlocked ?? false,
  } as UserProfile;
}

export async function getCurrentUser(): Promise<User> {
  const { data } = await api.get('/users/me');
  return transformUser(data) as User;
}

export async function updateCurrentUser(updates: {
  displayName?: string;
  profileColor?: string;
}): Promise<User> {
  const { data } = await api.patch('/users/me', {
    display_name: updates.displayName,
    profile_color: updates.profileColor,
  });
  return transformUser(data) as User;
}

export async function getUserProfile(userId: string): Promise<UserProfile> {
  const { data } = await api.get(`/users/${userId}`);
  return transformUserProfile(data);
}

export async function followUser(userId: string): Promise<void> {
  await api.post(`/users/${userId}/follow`);
}

export async function unfollowUser(userId: string): Promise<void> {
  await api.delete(`/users/${userId}/follow`);
}

export async function blockUser(userId: string): Promise<void> {
  await api.post(`/users/${userId}/block`);
}

export async function unblockUser(userId: string): Promise<void> {
  await api.delete(`/users/${userId}/block`);
}

export async function getBlockedUsers(): Promise<User[]> {
  const { data } = await api.get('/users/me/blocked');
  return (data || []).map((user: any) => transformUser(user) as User);
}
